package com.appcreator.client.revenuecat

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.appcreator.blueprint.revenuecat.RevenuecatCustomerCenterComponent

@Composable
actual fun CustomerCenterComposable(
    modifier: Modifier,
    component: RevenuecatCustomerCenterComponent
) {
}